<template>
  <div>
    <BaseBarChartCard
      :labelsArray="getLabelsArray(TPAppsStats.TPAppsCountPerTPPerDuration)"
      chartLabel="عدد الطلبات"
      :dataArray="getDataArray(TPAppsStats.TPAppsCountPerTPPerDuration)"
    >
      <template v-slot:title>
         طلبات المنح لكل برنامج تدريبي
      </template>
      <template v-slot:durationSelection>
        <BaseSelect
          :items="durations"
          v-model="TPAppsStats.TPAppsCountPerTPDuration"
          chips
          dense
          placeholder="المدة الزمنية"
          value="value"
        >
          <template v-slot:item="{ item }"> خلال {{ item.label }} </template>
          <template v-slot:selection="{ item }">
            خلال {{ item.label }}
          </template>
        </BaseSelect>
      </template>
    </BaseBarChartCard>
  </div>
</template>

<script>
import { useStatisticsStore } from "@/modules/home/store/StatisticsStore";
import { mapActions, mapWritableState } from "pinia";
import BaseBarChartCard from "../../base_statistics_cards/BaseBarChartCard.vue";
import StatisticsDurations from "../../statics/StatisticsDurations";

export default {
  components: { BaseBarChartCard },
  methods: {
    ...mapActions(useStatisticsStore, ["getLabelsArray", "getDataArray","fetchTPsStatistics"]),
  },
  watch: {
    "TPAppsStats.TPAppsCountPerTPDuration": function () {
      this.fetchTPsStatistics()
        .then()
        .catch((err) => console.error(err));
    },
  },
  computed: {
    ...mapWritableState(useStatisticsStore, ["TPAppsStats"]),
  },
  data() {
    return {
      durations: StatisticsDurations,
    };
  },
};
</script>
